"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActivityFeedState = exports.ActivityFeedContextProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useSocket_1 = require("../../../hooks/useSocket");
const useFetchFeedActivities_1 = require("../api/useFetchFeedActivities");
const activityFiltersConfig_1 = require("../constants/activityFiltersConfig");
const useActivityFeedFiltersState_1 = require("../hooks/useActivityFeedFiltersState");
const useActivityFeedWebsocketToken_1 = require("../hooks/useActivityFeedWebsocketToken");
const useGetSocketEventListeners_1 = require("../hooks/useGetSocketEventListeners");
const ACTIVITY_FEED_SOCKET_NAMESPACE = '/shipment.activity-feed';
const ActivityFeedContext = (0, react_1.createContext)({});
const ActivityFeedContextProvider = ({ children, entities, isInternal, }) => {
    const mainEntity = entities.find(({ type }) => type === 'shipment') || entities[0];
    const [updateActivityTypes, setUpdateActivityTypes] = (0, react_1.useState)([]);
    const [filtersCount, setFiltersCount] = (0, react_1.useState)({});
    const { shipmentWebsocketToken, bookingWebsocketToken, websocketApp } = (0, useActivityFeedWebsocketToken_1.useActivityFeedWebsocketToken)(entities);
    const { initializeSocket: initializeShipmentSocket, createDomainEventsListeners: createShipmentDomainEventsListeners, disconnectSocket: disconnectShipmentSocket, } = (0, useSocket_1.useSocket)();
    const { initializeSocket: initializeBookingSocket, createDomainEventsListeners: createBookingDomainEventsListeners, disconnectSocket: disconnectBookingSocket, } = (0, useSocket_1.useSocket)();
    const eventListeners = (0, useGetSocketEventListeners_1.useGetSocketEventListeners)(entities, isInternal);
    const { selectedFilters, selectFilters } = (0, useActivityFeedFiltersState_1.useActivityFeedFiltersState)();
    const feedDataQuery = (0, useFetchFeedActivities_1.useFeedActivities)(entities.map((entity) => entity.id), selectedFilters, updateActivityTypes);
    const isCustomerFeed = mainEntity.type === 'customer';
    let filters;
    if (isCustomerFeed) {
        filters = activityFiltersConfig_1.customerFilterKeys;
    }
    else if (isInternal) {
        filters = [...activityFiltersConfig_1.filterKeys, ...activityFiltersConfig_1.additionalFilters];
    }
    else {
        filters = activityFiltersConfig_1.filterKeys;
    }
    const updateFiltersCountMap = (data) => {
        const { activityCountByType } = data?.[0] || {
            activityCountByType: [],
        };
        if (activityCountByType) {
            const availableUpdateActivityTypes = activityCountByType
                .filter(({ type }) => !(0, activityFiltersConfig_1.getNonUpdateActivityTypes)(filters).includes(type))
                .map(({ type }) => type);
            setUpdateActivityTypes(availableUpdateActivityTypes);
            const filtersCountReduceMap = activityCountByType?.reduce((acc, curr) => ({ ...acc, [curr.type]: curr.count }), {});
            const filtersCountMap = filters.reduce((acc, filterKey) => {
                return {
                    ...acc,
                    [filterKey]: (0, activityFiltersConfig_1.getActivityTypes)(filterKey, availableUpdateActivityTypes).reduce((sumAcc, activity) => {
                        return sumAcc + (filtersCountReduceMap?.[activity] || 0);
                    }, 0),
                };
            }, {});
            setFiltersCount(filtersCountMap);
        }
    };
    (0, react_1.useEffect)(() => {
        entities.forEach((entity) => {
            if (shipmentWebsocketToken && entity.type === 'shipment') {
                initializeShipmentSocket(websocketApp, ACTIVITY_FEED_SOCKET_NAMESPACE, { shipmentId: entity.id }, shipmentWebsocketToken);
                createShipmentDomainEventsListeners(eventListeners);
            }
            else if (bookingWebsocketToken && entity.type === 'booking') {
                initializeBookingSocket(websocketApp, ACTIVITY_FEED_SOCKET_NAMESPACE, { referenceId: entity.id }, bookingWebsocketToken);
                createBookingDomainEventsListeners(eventListeners);
            }
        });
        return () => {
            disconnectShipmentSocket();
            disconnectBookingSocket();
        };
    }, [shipmentWebsocketToken, bookingWebsocketToken]);
    (0, react_1.useEffect)(() => {
        if (feedDataQuery?.data)
            updateFiltersCountMap(feedDataQuery?.data?.pages);
    }, [feedDataQuery?.data]);
    const state = (0, react_1.useMemo)(() => ({
        entities,
        mainEntity,
        feedData: feedDataQuery,
        filters,
        filtersCount,
        selectFilters,
        selectedFilters,
        isInternal,
    }), [feedDataQuery, selectedFilters, isInternal]);
    return (0, jsx_runtime_1.jsxs)(ActivityFeedContext.Provider, { value: state, children: [" ", children] });
};
exports.ActivityFeedContextProvider = ActivityFeedContextProvider;
const useActivityFeedState = () => {
    const context = (0, react_1.useContext)(ActivityFeedContext);
    if (!context) {
        throw new Error('Must use useActivityFeedState in ActivityFeedContext');
    }
    return context;
};
exports.useActivityFeedState = useActivityFeedState;
//# sourceMappingURL=ActivityFeedContext.js.map